import React, { createContext, useContext, useState, useCallback } from 'react';

const ModalContext = createContext({
  isMachineModalOpen: false,
  setMachineModalOpen: () => {},
});

export const ModalProvider = ({ children }) => {
  const [isMachineModalOpen, setIsMachineModalOpen] = useState(false);

  const setMachineModalOpen = useCallback((isOpen) => {
    setIsMachineModalOpen(Boolean(isOpen));
  }, []);

  const value = {
    isMachineModalOpen,
    setMachineModalOpen,
  };

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
};

export const useModal = () => {
  return useContext(ModalContext);
};

